import { render, staticRenderFns } from "./ReviewSection.vue?vue&type=template&id=2e58c3f9&scoped=true&"
import script from "./ReviewSection.vue?vue&type=script&lang=js&"
export * from "./ReviewSection.vue?vue&type=script&lang=js&"
import style0 from "./ReviewSection.vue?vue&type=style&index=0&id=2e58c3f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e58c3f9",
  null
  
)

export default component.exports